import axios from 'axios'
import {
  buildMemoryStorage,
  defaultHeaderInterpreter,
  defaultKeyGenerator,
  setupCache
} from 'axios-cache-interceptor'

const axiosInstance = axios.create()

export const httpClient = setupCache(axiosInstance, {
  storage: buildMemoryStorage(),
  generateKey: defaultKeyGenerator,
  headerInterpreter: defaultHeaderInterpreter,
  methods: ['get'],
  ttl: 1800000, // 30 min
  debug: process.env.NODE_ENV === 'development' ? console.log : undefined
})
